import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import Modal from '@zg-rentals/multibrand-ui/lib/Modal';
import NotificationContainer from '../NotificationContainer';
import StackedNotificationsContainer from '../StackedNotificationsContainer';
import userPersonas from '@common/constants/userPersonas';
import '../Page/index.scss';

interface IPaymentsModalProps {
  className?: string;
  dataAutoTestId?: string;
  isWizard?: boolean;
  header?: string;
  subHeader?: React.ReactNode;
  onRequestClose?: () => void;
  onClickBack?: () => void;
  persona?: string;
  children: any;
  isInWebView: boolean;
  isAlwaysFullScreen: boolean;
}
function PaymentsModal({
  className,
  dataAutoTestId,
  isWizard,
  header,
  subHeader,
  persona,
  onClickBack,
  onRequestClose,
  children,
  isInWebView,
  isAlwaysFullScreen,
}: IPaymentsModalProps): JSX.Element {
  return (
    <Modal
      className={cx('Payments-Page', className)}
      id={dataAutoTestId}
      header={header}
      subHeader={subHeader}
      isOpen
      isWizard={isWizard}
      isParentBody={false}
      isInWebView={isInWebView}
      shouldBypassBodyStyling
      hideBackButton={!onClickBack}
      hideCloseButton={!onRequestClose}
      onClickBack={onClickBack}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={false}
      isAlwaysFullScreen={isAlwaysFullScreen}
    >
      {persona && <NotificationContainer modal persona={persona} />}
      {persona && <StackedNotificationsContainer modal persona={persona} />}
      {children}
    </Modal>
  );
}

PaymentsModal.defaultProps = {
  className: undefined,
  dataAutoTestId: '',
  isWizard: true,
  header: '',
  subHeader: null,
  onRequestClose: undefined,
  onClickBack: undefined,
  isAlwaysFullScreen: false,
  persona: userPersonas.LANDLORD,
};

const mapStateToProps = (state) => ({
  isInWebView: state.app.isInWebView,
});

export default connect(mapStateToProps)(PaymentsModal);
